<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" app>
      <v-list dense>
        <router-link to="/">
          <v-list-item link>
            <v-list-item-action>
              <v-icon>mdi-home</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Home</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </router-link>
        <router-link to="/company">
          <v-list-item link>
            <v-list-item-action>
              <v-icon>mdi-domain</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Company</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </router-link>
        <router-link to="/machine">
          <v-list-item link>
            <v-list-item-action>
              <v-icon>mdi-memory</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Machine</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </router-link>
        <router-link to="/sensor">
          <v-list-item link>
            <v-list-item-action>
              <v-icon>mdi-dialpad</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Sensor</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </router-link>
        <router-link to="/alarm">
          <v-list-item link>
            <v-list-item-action>
              <v-icon>mdi-dialpad</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Alarm</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </router-link>
        <router-link to="/warning">
          <v-list-item link>
            <v-list-item-action>
              <v-icon>mdi-dialpad</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Warning</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </router-link>
        <router-link to="/line">
          <v-list-item link>
            <v-list-item-action>
              <v-icon>mdi-forum</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Line</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </router-link>
        <Logout />
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="indigo" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>SYNERGY Connect Admin</v-toolbar-title>
    </v-app-bar>

    <v-main>
      <router-view v-if="authenticated" />
      <Auth v-else />
      <Error />
    </v-main>
    <v-footer color="indigo" app>
      <span class="white--text">&copy; 2020</span>
    </v-footer>
  </v-app>
</template>

<script>
import Auth from './Auth/Auth'
import Logout from './Auth/Logout'
import Error from './components/Error'

export default {
  data: () => ({
    drawer: null
  }),
  created() {
    this.$store.dispatch('auth/attemptLocalToken')
  },
  computed: {
    authenticated() {
      return this.$store.getters['auth/authenticated']
    }
  },
  components: {
    Auth,
    Logout,
    Error
  }
}
</script>

<style lang="scss">
a {
  color: inherit !important;
  text-decoration: none;
}
</style>
